import { render, staticRenderFns } from "./UserIconComponent.vue?vue&type=template&id=dc970322&scoped=true"
import script from "./UserIconComponent.vue?vue&type=script&lang=js"
export * from "./UserIconComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc970322",
  null
  
)

export default component.exports